<template>
  <div class="my-main-content-web">
    <div style="margin-top:5vh;  padding-bottom: 48px;max-width: 1280px; margin-right: 8vw; margin-left: 8vw;">
      <h3 class="text3D">後台設定</h3>

      <el-col :span="24">
        <div @click="$routerTo('/Admin/AreaSet')">
          <el-card :body-style="{ padding: '10px' }" style="background-color: currentColor; margin:10px">
            <div style="padding: 14px;">
              <span class="two-line-text text3D">區域管理</span>
            </div>
          </el-card>
        </div>
      </el-col>

      <el-col :span="24">
        <div @click="$routerTo('/AdminDocumentList')">
          <el-card :body-style="{ padding: '10px' }" style="background-color: currentColor; margin:10px">
            <div style="padding: 14px;">
              <span class="two-line-text text3D">文獻管理</span>
            </div>
          </el-card>
        </div>
      </el-col>

      <el-col :span="24">
        <div @click="$routerTo('/Admin/QRcode/Setting')">
          <el-card :body-style="{ padding: '10px' }" style="background-color: currentColor; margin:10px">
            <div style="padding: 14px;">
              <span class="two-line-text text3D">管理 QRcode</span>
            </div>
          </el-card>
        </div>
      </el-col>

      <el-col :span="24">
        <div @click="$routerTo('/AdminQRcode')">
          <el-card :body-style="{ padding: '10px' }" style="background-color: currentColor; margin:10px">
            <div style="padding: 14px;">
              <span class="two-line-text text3D">製作 QRcode</span>
            </div>
          </el-card>
        </div>
      </el-col>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {},
  mounted() {
    this.$store.commit("set_page", location.hash);
  },
  methods: {}
};
</script>
